import React, { useState } from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import * as api from "core-module/services/api";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

// @material-ui/core components
import Storage from "@material-ui/icons/Storage";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

import ApiAlert from "../../common/components/ApiAlert/ApiAlert.jsx";
import { showAlert } from "../../core-module/services/errorAlert/reducers"
import store from '../../store'


const importedStyle = dashboardStyle;
const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: {
    ...importedStyle.cardTitle,
    margin: 30,
    marginTop: 30,
  },
  stats: importedStyle.stats,
  buttonBox: {
    display: "flex",
    alignSelf: "center",
  },
  buttonStyle: {
    margin: "20px",
  },
  target: {
    width: "100%",
  },
  code: {
    textAlign: "left",
    whiteSpace: "pre-wrap",
  },
};

const ApiBrowser = (props) => {
  const { classes } = props;
  const [target, setTarget] = useState("");
  const [method, setMethod] = useState("GET");
  const [pretty, setPretty] = useState("t");
  const [schema, setSchema] = useState(false);
  const [body, setBody] = useState("");
  const [status, setStatus] = useState("");
  const [response, setResponse] = useState("");


  function handleTargetChange(event) {
    setTarget(event.target.value);
  }

  function handleBodyChange(event) {
    setBody(event.target.value);
  }

  function handleMethodChange(event) {
    setMethod(event.target.value);
  }

  function handlePrettyChange(event) {
    setPretty(event.target.value);
  }

  function handleSchemaChange(event) {
    setSchema(event.target.value);
  }

  async function submitForm(event) {
    event.preventDefault();
    let schemaVal = 0;
    if (!schema) {
      schemaVal = "f";
    }
    try {
      const res = await api.fetchApi(
        `?target=${target}&schema=${schemaVal}`,
        method,
        body
      );
      setStatus(res.status);
      const resData = await res.text();
      const resDataArray = JSON.parse(resData);
      if (pretty === "t") {
        setResponse(JSON.stringify(JSON.parse(resData), null, 4));
      } else {
        setResponse(resData);
      }
      if (resDataArray.error == 1) {
        // console.log(response)
        store.dispatch(showAlert()); 
      }
    } catch (e) {
      setResponse(e.message);
      store.dispatch(showAlert());
    }
  }

  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Storage />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>API Browser</h4>
            </CardHeader>
            <CardBody className={classes.buttonBox}>
              <GridContainer align="center" justify="center">
                <form onSubmit={submitForm}>
                  <GridItem xs={12}>
                    <label>
                      Target: <ApiAlert status={status} message={response}></ApiAlert>
                      <input
                        className={classes.target}
                        type="text"
                        value={target}
                        onChange={handleTargetChange}
                      />
                    </label>
                  </GridItem>
                  <GridItem xs={12}>
                    <label>
                      Method:{" "}
                      <select value={method} onChange={handleMethodChange}>
                        <option value="GET">GET</option>
                        <option value="POST">POST</option>
                      </select>
                    </label>
                  </GridItem>
                  <GridItem xs={12}>
                    <label>
                      Pretty print:{" "}
                      <select value={pretty} onChange={handlePrettyChange}>
                        <option value={"t"}>Yes</option>
                        <option value={"f"}>No</option>
                      </select>
                    </label>
                  </GridItem>
                  <GridItem xs={12}>
                    <label>
                      Schema:{" "}
                      <select value={schema} onChange={handleSchemaChange}>
                        <option value={true}>Yes</option>
                        <option value={false}>No</option>
                      </select>
                    </label>
                  </GridItem>
                  <GridItem xs={12}>
                    <label>
                      POST body:
                      <textarea
                        className={classes.target}
                        value={body}
                        onChange={handleBodyChange}
                      />
                    </label>
                  </GridItem>
                  <GridItem xs={12}>
                    <input type="submit" value="Submit" />
                  </GridItem>
                </form>
                <GridItem xs={12}>
                  <br />
                  <br />
                  <code>Status: {status}</code>
                  <code className={classes.code}>
                    Response:{" "}
                    {pretty === "t"
                      ? response
                          .split("\n")
                          .map((str, i) => (
                            <p key={i}>{str.replace(/\s/g, " ")}</p>
                          ))
                      : response}
                  </code>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};
export default withStyles(styles)(ApiBrowser);
